import React from 'react';

import { Icon, StepSeparator } from '@chakra-ui/react';
import { MdHome, MdLock, MdOutlineAdminPanelSettings } from 'react-icons/md';
import { TbReportSearch } from 'react-icons/tb';
import { BsBank2, BsFillCartFill, BsFillCartPlusFill } from 'react-icons/bs';
import { BsCashCoin } from 'react-icons/bs';
import { IoMdSettings } from 'react-icons/io';

// Admin Imports
import MainDashboard from 'views/admin/default';
import Report from 'views/admin/report';
import JournalVoucher from 'views/admin/journal-vouchers';
import Sales from 'views/admin/sales';
import Cash from 'views/admin/cash';
import Bank from 'views/admin/bank';
import RTL from 'views/admin/rtl';
import Customers from 'views/admin/masters/Pages/CustomerMaster/Customers';
import VendorMaster from 'views/admin/masters/Pages/VendorMaster/VendorMaster';
import AllAccountMaster from 'views/admin/masters/Pages/AllAccountMaster/AllAccountMaster';
import BankAccounts from 'views/admin/masters/Pages/BankAccounts/BankAccounts';
import ItemMaster from 'views/admin/masters/Pages/ItemMaster/ItemMaster';
import CategoryMaster from 'views/admin/masters/Pages/CategoryMaster/CategoryMaster';
import BrandMaster from 'views/admin/masters/Pages/BrandMaster/BrandMaster';
import SeriesMaster from 'views/admin/masters/Pages/SeriesMaster/SeriesMaster';
import ModelMaster from 'views/admin/masters/Pages/ModelMaster/ModelMaster';
import ItemGroupMaster from 'views/admin/masters/Pages/ItemGroupMaster/ItemGroupMaster';
import UnitMaster from 'views/admin/masters/Pages/UnitMaster/UnitMaster';
import WarehouseMaster from 'views/admin/masters/Pages/WarehouseMaster/WarehouseMaster';
import ScreenMaster from 'views/admin/masters/Pages/ScreenMaster/ScreenMaster';
import TransportMaster from 'views/admin/masters/Pages/TransportMaster/TransportMaster';
import DriverMaster from 'views/admin/masters/Pages/DriverMaster/DriverMaster';
import VehicleMaster from 'views/admin/masters/Pages/VehicleMaster/VehicleMaster';
import ColorMaster from 'views/admin/masters/Pages/ColorMaster/ColorMaster';
import StyleMaster from 'views/admin/masters/Pages/StyleMaster/StyleMaster';
import SizeMaster from 'views/admin/masters/Pages/SizeMaster/SizeMaster';
import HsnMaster from 'views/admin/masters/Pages/HsnMaster/HsnMaster';
import DaybookMaster from 'views/admin/masters/Pages/DaybookMaster/Daybook';
import CountryMaster from 'views/admin/masters/Pages/CountryMaster/CountryMaster';
import StateMaster from 'views/admin/masters/Pages/StateMaster/StateMaster';
import AreaMaster from 'views/admin/masters/Pages/AreaMaster/AreaMaster';
import SalesRepresentativeMaster from 'views/admin/masters/Pages/SalesRepresentativeMaster/SalesRepresentativeMaster';
import {
   columnsItemDataDevelopment,
   columnsBankAccounts,
   columnsCategoryDataDevelopment,
   columnsBrandDataDevelopment,
   columnsSeriesDataDevelopment,
   columnsModelDataDevelopment,
   columnsItemGroupDataDevelopment,
   columnsWarehouseDataDevelopment,
   columnsUnitData,
   columnsScreenData,
   columnsTransportDataDevelopment,
   columnsDriverDataDevelopment,
   columnsVehicleDataDevelopment,
   columnsColorDataDevelopment,
   columnsStyleDataDevelopment,
   columnsSizeDataDevelopment,
   columnsHsnDataDevelopment,
   daybookColumns,
   columnsStateDataDevelopment,
   columnsCountryDataDevelopment,
   columnsCityDataDevelopment,
   columnsLedgerDataDevelopment,
   columnsSalesRepresentativeDataDevelopment,
} from 'views/admin/customDataTable/variables/columnsData';
import tableDataDevelopment from 'views/admin/customDataTable/variables/columnsItemDataDevelopment.json';
import tableDataBankAcc from 'views/admin/customDataTable/variables/tableDataBankAcc.json';
import tableDataUnit from 'views/admin/customDataTable/variables/tableDataUnit.json';
import tableDataScreen from 'views/admin/customDataTable/variables/tableDataScreen.json';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import CityMaster from 'views/admin/masters/Pages/CityMaster/CityMaster';
import LedgerMaster from 'views/admin/masters/Pages/LedgerMaster/LedgerMaster';
import SalesInvoiceMaster from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceMaster';

import SalesInvoice from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoice';
import SalesChallan from 'views/admin/salesChallan/SalesChallan';
import SalesOrder from 'views/admin/SalesOrder/SalesOrder';
import SalesInvoiceForDaybook from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceForDaybook';

import SalesReturnInvoice from 'views/admin/salesReturn/Pages/SalesReturnInvoiceMaster/SalesReturnInvoice';
import SalesReturnInvoiceForDaybook from 'views/admin/salesReturn/Pages/SalesReturnInvoiceMaster/SalesReturnInvoiceForDaybook';

import PurchaseInvoice from 'views/admin/purchase/Pages/PurchaseInvoiceMaster/PurchaseInvoice';
import PurchaseChallan from 'views/admin/PurchaseChallan/PurchaseChallan';
import PurchaseOrder from 'views/admin/PurchaseOrder/PurchaseOrder';
import PurchaseInvoiceForDaybook from 'views/admin/purchase/Pages/PurchaseInvoiceMaster/PurchaseInvoiceForDaybook';

import PurchaseReturnInvoice from 'views/admin/purchaseReturn/Pages/PurchaseReturnInvoiceMaster/PurchaseReturn';
import PurchaseChallanAddForm from 'views/admin/PurchaseChallan/PurchaseChallanAddForm';
import PurchaseOrderAddForm from 'views/admin/PurchaseOrder/PurcahseOrderAddForm';
import PurchaseReturnForDaybook from 'views/admin/purchaseReturn/Pages/PurchaseReturnInvoiceMaster/PurchaseReturnForDaybook';

import BillTermMaster from 'views/admin/masters/Pages/BillTermMaster/BillTermMaster';
import { columnsBillTermData } from 'views/admin/customDataTable/variables/columnsData';
import PurchaseInvoiceMaster from 'views/admin/purchase/Pages/PurchaseInvoiceMaster/PurchaseInvoiceMaster';
import PurchaseInvoiceMasterForm from 'views/admin/purchase/Pages/PurchaseInvoiceMaster/PurchaseInvoiceMasterForm';
import SalesReturnInvoiceMaster from 'views/admin/salesReturn/Pages/SalesReturnInvoiceMaster/SalesReturnInvoiceMaster';
import SalesReturnInvoiceMasterForm from 'views/admin/salesReturn/Pages/SalesReturnInvoiceMaster/SalesReturnInvoiceMasterForm';
import PurchaseReturnInvoiceMaster from 'views/admin/purchaseReturn/Pages/PurchaseReturnInvoiceMaster/PurchaseReturnInvoiceMaster';
import PurchaseReturnInvoiceMasterForm from 'views/admin/purchaseReturn/Pages/PurchaseReturnInvoiceMaster/PurchaseReturnInvoiceMasterForm';
import GSTR1 from 'views/admin/report/Pages/GSTR1';
import GSTR3B from 'views/admin/report/Pages/GSTR3B';
import AllTransaction from 'views/admin/report/Pages/AllTransaction';
import ProfitLoss from 'views/admin/report/Pages/ProfitLoss';
import PurchaseDetail from 'views/admin/report/Pages/PurchaseDetail';
import PurchaseSummary from 'views/admin/report/Pages/PurchaseSummary';
import SalesDetail from 'views/admin/report/Pages/SalesDetail';
import SalesSummary from 'views/admin/report/Pages/SalesSummary';
import Statement from 'views/admin/report/Pages/Statement';
import Outstanding from 'views/admin/report/Pages/Outstanding';
import BalanceSheet from 'views/admin/report/Pages/BalanceSheet';
import Expense from 'views/admin/report/Pages/Expense';
import Income from 'views/admin/report/Pages/Income';
import ItembyContact from 'views/admin/report/Pages/ItembyContact';
import Stock from 'views/admin/report/Pages/Stock';
import StoreStock from 'views/admin/report/Pages/StoreStock';
import InventoryDetail from 'views/admin/report/Pages/InventoryDetail';
import BillToBillProfit from 'views/admin/report/Pages/BillToBillProfit';
import TDSREPORT from 'views/admin/report/Pages/TDSREPORT';
import GSTR2AB2BReconcilation from 'views/admin/report/Pages/GSTR2AB2BReconcilation';
import Settings from 'views/admin/settings/setting';
import Utility from 'views/admin/utility/setting';
import Globalimei from 'views/admin/global IMEI/globalimei';

import SalesInvoiceForm from './views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceForm';
import SalesForm from './views/admin/invoices-forms/pages/SalesInvoiceForm';
import SalesChallanAddForm from './views/admin/salesChallan/SalesChallanAddForm';
import SalesOrderAddForm from './views/admin/SalesOrder/SalesOrderAddForm';

import SalesReturnInvoiceForm from './views/admin/salesReturn/Pages/SalesReturnInvoiceMaster/SalesReturnInvoiceForm';

import PurchaseReturnInvoiceForm from './views/admin/purchaseReturn/Pages/PurchaseReturnInvoiceMaster/PurchaseReturnInvoiceForm';

import PurchaseInvoiceForm from './views/admin/purchase/Pages/PurchaseInvoiceMaster/PurchaseInvoiceForm';
import SerialStock from 'views/admin/report/Pages/SerialStock';

// import Ledger from 'views/admin/report/Pages/Ledger';

// issue
import IssueMaster from './views/admin/inventory/Pages/IssueMaster/IssueMaster';
import IssueReturnMaster from './views/admin/inventory/Pages/IssueMaster/IssueReturnMaster';
import StockTransferMaster from './views/admin/inventory/Pages/StockTransferMaster/StockTransferMaster';
import IssueForm from './views/admin/inventory/Pages/IssueMaster/IssueMasterForm';
import ReceiveReturnMaster from './views/admin/inventory/Pages/ReceiveMaster/ReceiveReturnMaster';
import ReceiveMaster from './views/admin/inventory/Pages/ReceiveMaster/ReceiveMaster';
import ReceiveForm from './views/admin/inventory/Pages/ReceiveMaster/ReceiveForm';
import ReceiveMasterForReceiveOnly from './views/admin/inventory/Pages/ReceiveMaster/ReceiveMasterForReceiveOnly';
import ReceiveMasterIssueToVender from './views/admin/inventory/Pages/ReceiveMaster/ReceiveMasterIssueToVender';
import ReceiveMasterReceiveFormVender from './views/admin/inventory/Pages/ReceiveMaster/ReceiveMasterReceiveFormVender';
import ReceiveMasterSold from './views/admin/inventory/Pages/ReceiveMaster/ReceiveMasterSold';
import { BiAbacus } from 'react-icons/bi';

import ManageDaybook from '../src/views/admin/sales/Pages/SalesInvoiceMaster/ManageDaybook';

import SaleInvoiceIcon from '../src/assets/img/nfts/sales invoice.png';
import SaleReturnIcon from '../src/assets/img/nfts/Sale Return.png';
import PurchaseInvoiceIcon from '../src/assets/img/nfts/Purchase Invoice.png';
import PurchaseReturnIcon from '../src/assets/img/nfts/Purchase Return.png';
import IssueIcon from '../src/assets/img/nfts/Issue.png';
import ReceiveIcon from '../src/assets/img/nfts/Receive.png';
import ItemSerialwiseHistory from 'views/admin/report/Pages/ItemSerialwiseHistory';
import TrialBalance from 'views/admin/report/Pages/TrialBalance';
import { columnsAreaDataDevelopment } from 'views/admin/customDataTable/variables/columnsData';
import TransactionHistory from 'views/admin/report/Pages/TransactionHistory';
import SalesReturnDetail from 'views/admin/report/Pages/SalesReturnDetail';
import SalesReturnSummary from 'views/admin/report/Pages/SalesReturnSummary';
import PurchaseReturnDetail from 'views/admin/report/Pages/PurchaseReturnDetail';
import PurchaseReturnSummary from 'views/admin/report/Pages/PurchaseReturnSummary';
import SizeMasterNew from 'views/admin/masters/Pages/SizeMaster/SizeMasterNew';

const saleTabs = [
   // { label: 'Order', value: 'order', path: 'sales/order', img: SaleInvoiceIcon },
   { label: 'Invoice', value: 'invoice', path: 'sales/invoice', img: SaleInvoiceIcon },
   { label: 'Return', value: 'return', path: 'sales/return', img: SaleReturnIcon },
   { label: 'Challan', value: 'challan', path: 'sales/challan', img: SaleInvoiceIcon },
];

const purchaseTabs = [
   // { label: 'Order', value: 'order', path: 'purchase/order', img: SaleReturnIcon },
   { label: 'Invoice', value: 'invoice', path: 'purchase/invoice', img: PurchaseInvoiceIcon },
   { label: 'Return', value: 'return', path: 'purchase/return', img: PurchaseReturnIcon },
   { label: 'Challan', value: 'challan', path: 'purchase/challan', img: SaleInvoiceIcon },
];

const inventoryTabs = [
   { label: 'Issue', value: 'issue', path: 'inventory/issue', img: IssueIcon },
   { label: 'Receive', value: 'receive', path: 'inventory/receive', img: ReceiveIcon },
   { label: 'Stock Transfer', value: 'stocktransfer', path: 'inventory/stocktransfer', img: ReceiveIcon },
];

const routes = [
   {
      name: 'Dashboard',
      layout: '/admin',
      path: '/default',
      shortcut: 'D',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MainDashboard />,
   },
   {
      type: 'separator',
   },
   {
      name: 'Masters',
      layout: '/admin',
      path: '/masters/customers',
      shortcut: 'M',
      parentFor: [
         '/masters',
         '/masters/customers',
         '/masters/vendors',
         '/masters/allaccount',
         '/masters/items',
         '/masters/ledger',
         '/masters/daybook',
         '/masters/bankbranch',
         '/masters/transport',
         '/masters/other/color',
      ],
      icon: <Icon as={TbReportSearch} width="20px" height="20px" color="inherit" />,
      component: (
         <Customers
            // columnsData={columnsDataCustomerMaster}
            tableData={tableDataDevelopment}
         />
         // component: <MainDashboard />, for Dropdown
      ),
   },
   {
      name: 'Reports',
      layout: '/admin',
      path: '/report',
      icon: <Icon as={TbReportSearch} width="20px" height="20px" color="inherit" />,
      shortcut: 'R',
      parentFor: [
         '/report',
         '/report/ProfitLoss',
         '/report/BalanceSheet',
         '/report/Statement',
         '/report/Outstanding',
         '/report/Ledger',
         '/report/Expenses',
         '/report/Income',
         '/report/Stock',
         '/report/InventoryDetail',
         '/report/BillToBillProfit',
         '/report/TDSREPORT',
         '/report/GSTR1',
         '/report/GSTR3B',
         '/report/PurchaseDetail',
         '/report/PurchaseReturnDetail',
         '/report/PurchaseSummary',
         '/report/PurchaseReturnSummary',
         '/report/SalesDetail',
         '/report/SaleReturnDetail',
         '/report/SaleSummary',
         '/report/SaleReturnSummary',
         '/report/ItemByContact',
         '/report/AllTransaction',
         '/report/GSTR2AB2BReconcilation',
      ],
      component: <Report />,
      secondary: true,
   },
   {
      type: 'separator',
   },
   {
      name: 'Sales',
      layout: '/admin',
      path: '/sales',
      icon: <Icon as={BsFillCartFill} width="20px" height="20px" color="inherit" />,
      parentFor: [
         '/sales/invoice',
         '/sales/return',
         '/sales/challan',
         '/sales/order',
         '/sales/invoice/add',
         '/sales/invoice/edit/:id',
         '/sales/return/add',
         '/sales/return/edit/:id',
         '/sales/challan/add',
         '/sales/challan/edit/:id',
         '/sales/order/add',
         '/sales/order/edit/:id',
      ],
      shortcut: 'S',
      items: saleTabs.map((tab, index) => ({
         name: tab.label,
         path: `/${tab.path}`,
         layout: '/admin',
         icon: <img src={tab.img} alt={tab.label} width="20px" height="20px" />,
         exact: true,
         ...(index === 0 && { isDefault: true }),
      })),
      redirect: '/sales/invoice',
      secondary: true,
      isActive: (match, location) => {
         return location.pathname.startsWith('/admin/sales');
      },
   },
   {
      name: 'Purchase',
      layout: '/admin',
      path: '/purchase',
      // Assuming BsFillCartPlusFill is imported from 'react-icons/bs'
      icon: <Icon as={BsFillCartPlusFill} width="20px" height="20px" color="inherit" />,
      parentFor: [
         '/purchase/invoice',
         '/purchase/return',
         '/purchase/challan',
         '/purchase/order',
         '/purchase/invoice/add',
         '/purchase/invoice/edit/:id',
         '/purchase/return/add',
         '/purchase/return/edit/:id',
         '/purchase/challan/add',
         '/purchase/challan/edit/:id',
         '/purchase/order/add',
         '/purchase/order/edit/:id',
      ],
      shortcut: 'P',
      items: purchaseTabs.map((tab, index) => ({
         name: tab.label,
         path: `/${tab.path}`,
         layout: '/admin',
         icon: <img src={tab.img} alt={tab.label} width="20px" height="20px" />, // Use <img> tag for image icons
         exact: true,
         ...(index === 0 && { isDefault: true }),
      })),
      secondary: true,
      isActive: (match, location) => {
         return location.pathname.startsWith('/admin/purchase'); // Use startsWith for broader matching
      },
   },
   {
      name: 'Inventory',
      layout: '/admin',
      // Assuming TbReportSearch is imported from 'react-icons/tb'
      icon: <Icon as={TbReportSearch} width="20px" height="20px" color="inherit" />,
      path: '/inventory',
      shortcut: 'I',
      parentFor: [
         '/inventory/issue',
         '/inventory/issue/add',
         '/inventory/issue/edit/:id',
         '/inventory/receive',
         '/inventory/receive/onlyreceive',
         '/inventory/receive/issutovendor',
         '/inventory/receive/receivfromvendor',
         '/inventory/receive/sold',
         '/inventory/receive/add',
         '/inventory/receive/edit/:id',
         '/inventory/stocktransfer',
      ],
      items: inventoryTabs.map((tab, index) => ({
         name: tab.label,
         path: `/${tab.path}`,
         layout: '/admin',
         icon: <img src={tab.img} alt={tab.label} width="20px" height="20px" />, // Use <img> tag for image icons
         exact: true,
         ...(index === 0 && { isDefault: true }),
      })),
      secondary: true,
      isActive: (match, location) => {
         return location.pathname.startsWith('/admin/inventory'); // Use startsWith for broader matching
      },
   },
   {
      name: 'Cash',
      layout: '/admin',
      icon: <Icon as={BsCashCoin} width="20px" height="20px" color="inherit" />,
      shortcut: 'C',
      path: '/cash',
      component: <Cash />,
   },
   {
      name: 'Bank',
      layout: '/admin',
      icon: <Icon as={BsBank2} width="20px" height="20px" color="inherit" />,
      shortcut: 'B',
      exact: true,
      path: '/bank',
      activeSegment: '/bank',
      parentFor: ['admin/bank'],
      component: <Bank />,
   },
   {
      type: 'separator',
   },
   {
      name: 'Journal Vouchers',
      layout: '/admin',
      path: '/journal-vouchers',
      icon: <Icon as={MdOutlineAdminPanelSettings} width="20px" height="20px" color="inherit" />,
      shortcut: 'J',
      component: <JournalVoucher />,
      secondary: true,
   },
   {
      type: 'separator',
   },
   {
      name: 'Settings',
      subName: 'Profile',
      layout: '/admin',
      path: '/setting',
      icon: <Icon as={IoMdSettings} width="20px" height="20px" color="inherit" />,
      component: <Settings />,
   },
   {
      name: 'Utility',
      subName: 'Utility',
      layout: '/admin',
      path: '/utility',
      icon: <Icon as={BiAbacus} width="20px" height="20px" color="inherit" />,
      component: <Utility />,
   },
   {
      type: 'separator',
   },
   {
      name: 'Global IMEI',
      layout: '/admin',
      path: `/globalimei`,
      icon: <Icon as={TbReportSearch} width="20px" height="20px" color="inherit" />,
      component: <Globalimei />,
   },
];

export const masterRoutes = [
   {
      name: 'Customers',
      subName: 'Master',
      layout: '/masters',
      path: '/masters/customers',
      activeSegment: '/masters',
      component: (
         <Customers
            // columnsData={columnsDataCustomerMaster}
            tableData={tableDataDevelopment}
         />
      ),
   },
   {
      name: 'Vendors',
      subName: 'Master',
      layout: '/masters',
      path: '/masters/vendors',
      activeSegment: '/masters',
      component: <VendorMaster columnsData={columnsItemDataDevelopment} tableData={tableDataDevelopment} />,
   },
   {
      name: 'All Account',
      subName: 'Master',
      layout: '/masters',
      path: '/masters/allaccount',
      component: <AllAccountMaster columnsData={columnsItemDataDevelopment} tableData={tableDataDevelopment} />,
   },
   {
      name: 'Items',
      subName: 'Master',
      layout: '/masters',
      path: '/masters/items',
      activeSegment: '/masters',
      component: <ItemMaster columnsData={columnsItemDataDevelopment} tableData={columnsItemDataDevelopment} />,
   },
   {
      name: 'Daybook',
      subName: 'Master',
      layout: '/masters',
      path: '/masters/daybook',
      activeSegment: '/masters',
      component: <DaybookMaster columnsData={daybookColumns} />,
   },
   {
      name: 'Ledger',
      subName: 'Master',
      layout: '/masters',
      path: '/masters/ledger',
      activeSegment: '/masters',
      component: <LedgerMaster columnsData={columnsLedgerDataDevelopment} />,
   },
   {
      name: 'Bank Branch',
      subName: 'Master',
      layout: '/masters',
      path: '/masters/bankbranch',
      exact: true,
      activeSegment: '/masters',
      component: <BankAccounts columnsData={columnsBankAccounts} tableData={tableDataBankAcc} />,
   },
   {
      name: 'masters',
      layout: '/masters',
      path: '/masters/transport',
      activeSegment: '/masters',
      component: <TransportMaster columnsData={columnsTransportDataDevelopment} />,
   },
   {
      name: 'Other',
      layout: '/masters',
      path: '/masters/other/color',
      activeSegment: '/masters',
      component: <ColorMaster columnsData={columnsColorDataDevelopment} />,
   },
   {
      name: 'Other',
      layout: '/masters',
      path: '/masters/other/sales-representative',
      activeSegment: '/masters',
      component: <SalesRepresentativeMaster columnsData={columnsSalesRepresentativeDataDevelopment} />,
   },
];

export const itemRoutes = [
   {
      name: 'Category',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/category',
      component: <CategoryMaster columnsData={columnsCategoryDataDevelopment} />,
   },
   {
      name: 'Brand',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/brand',
      component: <BrandMaster columnsData={columnsBrandDataDevelopment} />,
   },
   {
      name: 'Series',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/series',
      component: <SeriesMaster columnsData={columnsSeriesDataDevelopment} />,
   },
   {
      name: 'Model',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/model',
      component: <ModelMaster columnsData={columnsModelDataDevelopment} />,
   },
   {
      name: 'Items',
      subName: 'masters',
      layout: '/items',
      path: '/masters/items',
      component: <ItemMaster columnsData={columnsItemDataDevelopment} tableData={columnsItemDataDevelopment} />,
   },
   {
      name: 'Item Group',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/item-group',
      component: <ItemGroupMaster columnsData={columnsItemGroupDataDevelopment} />,
   },
   {
      name: 'Warehouse',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/warehouse',
      component: <WarehouseMaster columnsData={columnsWarehouseDataDevelopment} />,
   },
   {
      name: 'Unit',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/unit',
      component: <UnitMaster columnsData={columnsUnitData} tableData={tableDataUnit} />,
   },
   {
      name: 'Screen',
      subName: 'items',
      layout: '/items',
      path: '/masters/items/screen',
      component: <ScreenMaster columnsData={columnsScreenData} tableData={tableDataScreen} />,
   },
];

export const transportRoutes = [
   {
      name: 'Driver',
      subName: 'transport',
      layout: '/transport',
      path: '/masters/transport/driver',
      component: <DriverMaster columnsData={columnsDriverDataDevelopment} />,
   },
   {
      name: 'Vehicle',
      subName: 'transport',
      layout: '/transport',
      path: '/masters/transport/vehicle',
      component: <VehicleMaster columnsData={columnsVehicleDataDevelopment} />,
   },
   {
      name: 'Transport',
      subName: 'masters',
      layout: '/transport',
      path: '/masters/transport',
      component: <TransportMaster columnsData={columnsTransportDataDevelopment} />,
   },
];

export const daybookRoutes = [
   {
      name: 'Daybook',
      subName: 'daybook',
      layout: '/daybook',
      path: '/masters/daybook',
      component: <DriverMaster columnsData={columnsDriverDataDevelopment} />,
   },
   {
      name: 'Billterm',
      subName: 'daybook',
      layout: '/daybook',
      path: '/masters/daybook/bill-term',
      component: <BillTermMaster columnsData={columnsBillTermData} />,
   },
];

export const otherRoutes = [
   {
      name: 'Color',
      subName: 'other',
      layout: '/other',
      path: '/masters/other/color',
      component: <ColorMaster columnsData={columnsColorDataDevelopment} />,
   },
   {
      name: 'Style',
      subName: 'other',
      layout: '/other',
      path: '/masters/other/style',
      component: <StyleMaster columnsData={columnsStyleDataDevelopment} />,
   },
   {
      name: 'Size',
      subName: 'other',
      layout: '/other',
      path: '/masters/other/size',
      component: <SizeMaster columnsData={columnsSizeDataDevelopment} />,
      // component: <SizeMasterNew />,
   },
   {
      name: 'HSN',
      subName: 'other',
      layout: '/other',
      path: '/masters/items/hsn',
      component: <HsnMaster columnsData={columnsHsnDataDevelopment} />,
   },
   {
      name: 'Countries',
      subName: 'other',
      layout: '/other',
      path: '/masters/other/countries',
      component: <CountryMaster columnsData={columnsCountryDataDevelopment} />,
   },
   {
      name: 'States',
      subName: 'other',
      layout: '/other',
      path: '/masters/other/states',
      component: <StateMaster columnsData={columnsStateDataDevelopment} />,
   },
   {
      name: 'Cities',
      subName: 'other',
      layout: '/other',
      path: '/masters/other/cities',
      component: <CityMaster columnsData={columnsCityDataDevelopment} />,
   },
   {
      name: 'Areas',
      subName: 'other',
      layout: '/other',
      path: '/masters/other/area',
      component: <AreaMaster columnsData={columnsAreaDataDevelopment} />,
   },
];

export const saleRoutes = [
   {
      name: 'Invoice',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/invoice/managedaybook',
      activeSegment: '/sales',
      component: <ManageDaybook />,
   },
   {
      name: 'Invoice',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/invoice',
      activeSegment: '/sales',
      // component: <SalesInvoiceMaster />,
      component: <SalesInvoice />,
   },
   {
      name: 'Invoice',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/invoice/daybook/:id',
      activeSegment: '/sales',
      component: <SalesInvoiceForDaybook />,
   },
   {
      name: 'Invoice',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/invoice/add',
      component: <SalesInvoiceForm />,
      // component: <SalesInvoiceMasterForm />,
   },
   {
      name: 'Invoice',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/invoice/add/new',
      component: <SalesForm />,
      // component: <SalesInvoiceMasterForm />,
   },
   {
      name: 'Invoice',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/invoice/edit/:id',
      component: <SalesInvoiceForm />,
      // component: <SalesInvoiceMasterForm />,
   },
   {
      ame: 'Return',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/return/managedaybook',
      activeSegment: '/sales',
      component: <ManageDaybook />,
   },
   {
      name: 'Return',
      subName: 'Sale',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/return',
      // component: <SalesReturnInvoiceMaster />,
      component: <SalesReturnInvoice />,
   },
   {
      name: 'Return',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/return/daybook/:id',
      activeSegment: '/sales',
      component: <SalesReturnInvoiceForDaybook />,
   },
   {
      name: 'Return',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/return/add',
      component: <SalesReturnInvoiceForm />,
      // component: <SalesReturnInvoiceMasterForm />,
   },
   {
      name: 'Return',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/return/edit/:id',
      component: <SalesReturnInvoiceForm />,
      // component: <SalesReturnInvoiceMasterForm />,
   },
   {
      name: 'Challan',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/challan',
      activeSegment: '/sales',
      // component: <SalesInvoiceMaster />,
      component: <SalesChallan />,
   },
   {
      name: 'InvoChallanice',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/challan/managedaybook',
      activeSegment: '/sales',
      component: <ManageDaybook />,
   },
   {
      name: 'Challan',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/challan/add',
      component: <SalesChallanAddForm />,
      // component: <SalesInvoiceMasterForm />,
   },
   {
      name: 'Challan',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/challan/edit/:id',
      component: <SalesChallanAddForm />,
   },
   {
      name: 'Order',
      subName: 'Sale',
      layout: '/sales',
      path: '/sales/order',
      activeSegment: '/sales',
      // component: <SalesInvoiceMaster />,
      component: <SalesOrder />,
   },
   {
      name: 'Order',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/order/add',
      component: <SalesOrderAddForm />,
      // component: <SalesInvoiceMasterForm />,
   },
   {
      name: 'Order',
      layout: '/sales',
      activeSegment: '/sales',
      path: '/sales/order/edit/:id',
      component: <SalesOrderAddForm />,
   },
];

export const purchaseRoutes = [
   {
      name: 'Invoice',
      subName: 'Purchase',
      layout: '/purchase',
      path: '/purchase/invoice/managedaybook',
      activeSegment: '/purchase',
      component: <ManageDaybook />,
   },
   {
      name: 'Invoice',
      subName: 'Purchase',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/invoice/daybook/:id',
      component: <PurchaseInvoiceForDaybook />,
   },
   {
      name: 'Invoice',
      subName: 'Purchase',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/invoice',
      component: <PurchaseInvoice />,
   },
   {
      name: 'Invoice',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/invoice/add',
      // component: <PurchaseInvoiceMasterForm />,
      component: <PurchaseInvoiceForm />,
   },
   {
      name: 'Invoice',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/invoice/edit/:id',
      // component: <PurchaseInvoiceMasterForm />,
      component: <PurchaseInvoiceForm />,
   },
   {
      ame: 'Return',
      subName: 'Purchase',
      layout: '/purchase',
      path: '/purchase/return/managedaybook',
      activeSegment: '/purchase',
      component: <ManageDaybook />,
   },
   {
      name: 'Return',
      subName: 'Purchase',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/return',
      // component: <PurchaseReturnInvoiceMaster />,
      component: <PurchaseReturnInvoice />,
   },
   {
      name: 'Return',
      subName: 'Purchase',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/return/daybook/:id',
      component: <PurchaseReturnForDaybook />,
   },
   {
      name: 'Return',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/return/add',
      // component: <PurchaseReturnInvoiceMasterForm />,
      component: <PurchaseReturnInvoiceForm />,
   },
   {
      name: 'Return',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/return/edit/:id',
      // component: <PurchaseReturnInvoiceMasterForm />,
      component: <PurchaseReturnInvoiceForm />,
   },
   // {
   //   name: 'Return',
   //   layout: '/purchase',
   //   path: '/purchase/return',
   //   component: (
   //     <ItemMaster
   //       columnsData={columnsItemDataDevelopment}
   //       tableData={columnsItemDataDevelopment}
   //     />
   //   ),
   // },
   {
      name: 'Challan',
      subName: 'Purchase',
      layout: '/purchase',
      path: '/purchase/challan/managedaybook',
      activeSegment: '/purchase',
      component: <ManageDaybook />,
   },
   {
      name: 'Challan',
      subName: 'Purchase',
      layout: '/purchase',
      path: '/purchase/challan',
      activeSegment: '/purchase',
      component: <PurchaseChallan />,
   },
   {
      name: 'Challan',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/challan/add',
      component: <PurchaseChallanAddForm />,
   },
   {
      name: 'Challan',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/challan/edit/:id',
      component: <PurchaseChallanAddForm />,
   },
   {
      name: 'Order',
      subName: 'Purchase',
      layout: '/purchase',
      path: '/purchase/order',
      activeSegment: '/purchase',
      component: <PurchaseOrder />,
   },
   {
      name: 'Order',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/order/add',
      component: <PurchaseOrderAddForm />,
   },
   {
      name: 'Order',
      layout: '/purchase',
      activeSegment: '/purchase',
      path: '/purchase/order/edit/:id',
      component: <PurchaseOrderAddForm />,
   },
];

export const bankAndCashRoutes = [
   {
      name: 'Bank',
      layout: '/bank',
      activeSegment: '/bank',
      path: '/admin/bank/managedaybook',
      component: <ManageDaybook />,
   },
   {
      name: 'Cash',
      layout: '/cash',
      activeSegment: '/cash',
      path: '/admin/cash/managedaybook',
      component: <ManageDaybook />,
   },
];

export const reportRoutes = [
   {
      name: 'ProfitLoss',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/profitLoss',
      component: <ProfitLoss />,
   },
   {
      name: 'Balance Sheet',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/balanceSheet',
      component: <BalanceSheet />,
   },
   {
      name: 'Statement',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/statement',
      component: <Statement />,
   },
   {
      name: 'Outstanding',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/Outstanding',
      component: <Outstanding />,
   },
   {
      name: 'Expenses',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/expenses',
      component: <Expense />,
   },
   {
      name: 'Income',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/income',
      component: <Income />,
   },
   {
      name: 'Trial Balance',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/TrialBalance',
      component: <TrialBalance />,
   },
   {
      name: 'Purchase Detail',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/purchaseDetail',
      component: <PurchaseDetail />,
   },
   {
      name: 'Purchase Return Detail',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/PurchaseReturnDetail',
      component: <PurchaseReturnDetail />,
   },
   {
      name: 'Purchase Summary',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/purchaseSummary',
      component: <PurchaseSummary />,
   },
   {
      name: 'Purchase Summary',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/PurchaseReturnSummary',
      component: <PurchaseReturnSummary />,
   },
   {
      name: 'Sales Detail',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/salesDetail',
      component: <SalesDetail columnsData={columnsCityDataDevelopment} />,
   },
   {
      name: 'Sales Return Detail',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/SaleReturnDetail',
      component: <SalesReturnDetail columnsData={columnsCityDataDevelopment} />,
   },
   {
      name: 'Sale Summary',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/saleSummary',
      component: <SalesSummary />,
   },
   {
      name: 'Sales Return Summary',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/SaleReturnSummary',
      component: <SalesReturnSummary />,
   },
   {
      name: 'Transaction History',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/TransactionHistory',
      component: <TransactionHistory />,
   },
   {
      name: 'Item By Contact',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/itemByContact',
      component: <ItembyContact />,
   },
   {
      name: 'Stock',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/stock',
      component: <Stock />,
   },
   {
      name: 'Store Stock',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/PartyStock',
      component: <StoreStock />,
   },
   {
      name: 'SerialStock',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/SerialStock',
      component: <SerialStock />,
   },
   {
      name: 'Inventory Detail',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/InventoryDetail',
      component: <InventoryDetail />,
   },
   {
      name: 'Serial Wise Bill To Bill Profit',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/SerialWiseBillToBillProfit',
      component: <BillToBillProfit />,
   },
   {
      name: 'ItemSerialwiseHistory',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/ItemSerialwiseHistory',
      component: <ItemSerialwiseHistory />,
   },
   {
      name: 'TDS REPORT',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/tdsreport',
      component: <TDSREPORT />,
   },
   {
      name: 'GSTR1',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/gstr1',
      component: <GSTR1 />,
   },
   {
      name: 'GSTR3B',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/gstr3b',
      component: <GSTR3B />,
   },
   {
      name: 'AllTransaction',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/AllTransaction',
      component: <AllTransaction />,
   },
   {
      name: 'GSTR2AB2BReconcilation',
      subName: 'Report',
      layout: '/report',
      activeSegment: '/report',
      path: '/report/GSTR2AB2BReconcilation',
      component: <GSTR2AB2BReconcilation />,
   },
];

export const inventoryRoutes = [
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/issue',
      activeSegment: '/inventory',
      component: <IssueMaster />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/issue/managedaybook',
      activeSegment: '/inventory',
      component: <ManageDaybook />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/issue/issuereturn',
      activeSegment: '/inventory',
      component: <IssueReturnMaster />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/issue/add',
      activeSegment: '/inventory',
      component: <IssueForm />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/issue/edit/:id',
      activeSegment: '/inventory',
      component: <IssueForm />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive',
      activeSegment: '/inventory',
      component: <ReceiveMasterForReceiveOnly />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/managedaybook',
      activeSegment: '/inventory',
      component: <ManageDaybook />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/receivereturn',
      activeSegment: '/inventory',
      component: <ReceiveReturnMaster />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/all',
      activeSegment: '/inventory',
      component: <ReceiveMaster />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/only-receive',
      activeSegment: '/inventory',
      component: <ReceiveMasterForReceiveOnly />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/issue-to-vendor',
      activeSegment: '/inventory',
      component: <ReceiveMasterIssueToVender />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/receive-from-vendor',
      activeSegment: '/inventory',
      component: <ReceiveMasterReceiveFormVender />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/sold',
      activeSegment: '/inventory',
      component: <ReceiveMasterSold />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/add',
      activeSegment: '/inventory',
      component: <ReceiveForm />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/receive/edit/:id',
      activeSegment: '/inventory',
      component: <ReceiveForm />,
   },
   {
      name: 'Issue',
      subName: 'Inventory',
      layout: '/inventory',
      path: '/inventory/stocktransfer',
      activeSegment: '/inventory',
      component: <StockTransferMaster />,
   },
];

export default routes;
